import { render, staticRenderFns } from "./slope-paicha-form.vue?vue&type=template&id=c5d64a38&scoped=true"
import script from "./slope-paicha-form.vue?vue&type=script&lang=js"
export * from "./slope-paicha-form.vue?vue&type=script&lang=js"
import style0 from "./slope-paicha-form.vue?vue&type=style&index=0&id=c5d64a38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d64a38",
  null
  
)

export default component.exports